import { createReducer } from 'redux-act';
import {
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  registUser,
  successRegistUser,
  failRegistUser,
  reminderEmail,
  setData,
  successGetData,
} from '../actions/regist';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  isFetching: false,
  data: {},
  authcode: undefined,
  error: undefined,
};

const data = createReducer(
  {
    [setData]: (state, payload) => Object.assign({}, state, payload),
    [checkEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        data: payload,
        authcode: undefined,
        error: undefined,
      }),
    [reminderEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        data: payload,
        authcode: undefined,
        error: undefined,
      }),
    [failCheckEmail]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successCheckEmail]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        authcode: payload,
        error: undefined,
      }),
    [registUser]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failRegistUser]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successRegistUser]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        //data: {},
        //authcode: undefined,
        error: undefined,
      }),
    [successGetData]: (state, payload) =>
      Object.assign({}, state, payload, {
        isFetching: false,
        error: undefined,
      }),
  },
  initial
);

export default data;



// WEBPACK FOOTER //
// ./src/reducers/regist.js